import React from 'react';
import { FieldError as FieldErrorType } from 'react-hook-form';

import ValidationError from './HtmlInput/ValidationError';

export type ErrorResponse = {
  errorCode?: string;
  message?: string;
};

type FieldErrorProps = {
  error?: FieldErrorType | ErrorResponse | null;
  children?: React.ReactNode;
  isVisible?: boolean;
  className?: string;
  width: 'auto' | '100%';
};

export const FieldError = ({ error, children, isVisible, className, width }: FieldErrorProps) => {
  const hasError = isVisible || !!error;
  return hasError ? (
    <ValidationError errorMessage={error?.message ?? children} className={className} style={{ width }} />
  ) : null;
};
